import React from 'react';
import NotificationTable from '../notification-table';
import {history} from '../../../../store';

const EmailNotificationTable = ({
  notifications, onPreview, loadingEmail, ...rest
}) => {
  const actions = [
    {
      label: 'View',
      callback: row => onPreview(row.id),
      disabled: () => loadingEmail,
    },
    {
      label: 'Edit',
      callback: (row) => {
        history.push(`/admin/email-logs/${row.id}/edit`);
      },
      permissions: {
        action: 'modify-email',
        subjectClass: 'Notification'
      }
    }
  ];
  return (
    <NotificationTable
      title="Email"
      actions={actions}
      notifications={notifications}
      {...rest}
    />
  );
};

export default EmailNotificationTable;



// WEBPACK FOOTER //
// ./src/components/admin/notifications/email/email-notification-table.jsx